import * as React from "react";

const SvgGrafana = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
     <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    ><path d="M525 5105 c-218 -41 -397 -186 -470 -380 -48 -128 -54 -207 -54 -807
-1 -550 4 -661 35 -782 47 -182 167 -320 340 -390 162 -66 327 -77 1004 -67
l535 7 80 28 c237 82 388 257 435 506 7 35 11 288 10 690 0 715 0 713 -72 859
-74 151 -216 270 -388 327 -51 17 -108 19 -720 21 -516 1 -681 -1 -735 -12z"/>
<path d="M3218 5110 c-131 -22 -258 -89 -352 -185 -72 -73 -118 -146 -154
-247 l-27 -73 0 -695 c0 -647 1 -699 18 -755 58 -187 170 -320 342 -406 140
-69 157 -70 882 -67 617 4 641 4 714 25 119 33 195 77 281 160 82 81 124 148
156 254 38 124 43 234 40 869 -4 673 -1 639 -76 785 -52 101 -181 228 -283
278 -135 66 -140 67 -854 66 -352 -1 -661 -5 -687 -9z"/>
<path d="M542 2429 c-193 -29 -371 -155 -460 -326 -80 -154 -77 -125 -77 -868
0 -743 0 -743 75 -893 53 -105 167 -217 272 -267 147 -70 146 -70 888 -70 617
0 669 1 725 18 187 58 343 196 421 374 51 115 53 135 55 773 2 646 -2 708 -55
862 -53 150 -151 266 -281 328 -155 75 -134 74 -855 76 -356 1 -673 -2 -708
-7z"/>
<path d="M3770 2433 c-129 -14 -309 -67 -425 -126 -222 -112 -442 -336 -549
-560 -184 -385 -143 -846 107 -1217 118 -174 333 -355 510 -429 403 -167 864
-118 1193 127 438 327 618 903 439 1413 -71 203 -233 420 -417 559 -95 72
-272 161 -378 190 -151 42 -337 58 -480 43z"/></g>
  </svg>
);

export default SvgGrafana;
